import { YStack } from '@/components/ui/layout/layout';
import { ScrollMask } from '@/components/ui/ScrollMask';
import { Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

export const Header = ({ children }: { children: React.ReactNode }) => {
  return <YStack className="gap-0.5 px-0.5">{children}</YStack>;
};

export const HeaderDescription = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <Text className="text-sm text-foreground-muted">{children}</Text>;
};

export const Content = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <YStack className={cn('gap-6 max-w-4xl mx-auto w-full', className)}>
      {children}
    </YStack>
  );
};

export const Root = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <ScrollMask className={cn('h-full px-6 pb-6 scrollbar-hide', className)}>
      <YStack className="gap-6 max-w-4xl mx-auto w-full min-h-full">
        {children}
      </YStack>
    </ScrollMask>
  );
};
